var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.classArr},'div',_vm.attrs,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }